/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState} from 'react'
import {useDebounce} from '../../../../../../../_metronic/helpers'
import InputGroup from 'react-bootstrap/InputGroup'
import Form from 'react-bootstrap/Form'
import DatePicker from '../../../../../../components/DatePicker'

type DateRangeValue = [Date | null, Date | null]

const formatDateParam = (date: Date) => {
  const year = date.getFullYear()
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')

  return `${year}-${month}-${day}`
}

const UsersListSearchComponent = ({onSearch = (s: string) => {}, onFilter = (_params: object) => {}}) => {
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [dateRange, setDateRange] = useState<DateRangeValue>([null, null])
  const [startDate, endDate] = dateRange
  const debouncedSearchTerm = useDebounce(searchTerm, 650)

  useEffect(() => {
    if (debouncedSearchTerm !== undefined && searchTerm !== undefined) {
      if (!searchTerm || searchTerm.length > 2) {
        onSearch(searchTerm)
      }
    }
  }, [debouncedSearchTerm])

  return (
    <div className='d-flex align-items-center flex-wrap'>
      <div className='d-flex align-items-center position-relative my-1'>
        <InputGroup className='d-flex align-items-center'>
          <Form.Control
            placeholder='ค้นหาเลขที่เอกสาร, ผู้ขาย, เลขใบแจ้งหนี้'
            className='w-250px'
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
          />
          <InputGroup.Text
            onClick={() => {
              setSearchTerm('')
            }}
            className='cursor-pointer'
          >
            <i className={'fs-2 bi bi-' + (searchTerm ? 'x' : 'search')}></i>
          </InputGroup.Text>
        </InputGroup>
      </div>

      <div style={{width: 280}} className='ms-4'>
        <DatePicker
          selectsRange
          isClearable
          showMonthDropdown
          showYearDropdown
          inputGroupClassName='mb-0'
          name='dateRange'
          placeholderText='ช่วงวันที่ออกเอกสาร'
          startDate={startDate}
          endDate={endDate}
          dateFormat='dd/MM/yyyy'
          timeCaption='time'
          dropdownMode='select'
          onChange={(range: DateRangeValue) => {
            const nextRange: DateRangeValue = Array.isArray(range) ? range : [null, null]
            const [nextStartDate, nextEndDate] = nextRange

            setDateRange(nextRange)

            const nextParams: Record<string, string> = {}

            if (nextStartDate) {
              nextParams.startDate = formatDateParam(nextStartDate)
            }

            if (nextEndDate) {
              nextParams.endDate = formatDateParam(nextEndDate)
            }

            onFilter(nextParams)
          }}
        />
      </div>
    </div>
  )
}

export {UsersListSearchComponent}
